import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DoctorPreference, DoctorPreferenceEditModel, OfficeOption, PageModel } from '../model/doctor-preference.model';
import { TreatmentType } from '../model/treatmentType';

const basePath = '/api';

@Injectable({ providedIn: 'root' })
export class DoctorPreferenceClient {
    private readonly _http = inject(HttpClient);

    listByTreatmentId(treatmentId: string) {
        return this._http.get<DoctorPreference[]>(`${basePath}/treatments/${treatmentId}/doctor-preferences`);
    }

    save(treatmentId: string, doctorPreferenceId: string | null | undefined, model: DoctorPreferenceEditModel) {
        return this._http.post<{}>(
            `${basePath}/treatments/${treatmentId}/doctor-preferences/${doctorPreferenceId ?? ''}`,
            {
                ...model,
            }
        );
    }

    listOffices(search?: string, skip = 0, take = 50) {
        let params = new HttpParams().set('skip', skip).set('take', take);
        if (search) {
            params = params.set('search', search);
        }
        return this._http.get<PageModel<OfficeOption>>(`${basePath}/doctor-preferences/offices`, { params });
    }

    listTreatmentTypes(search?: string, skip = 0, take = 50) {
        let params = new HttpParams().set('skip', skip).set('take', take);
        if (search) {
            params = params.set('search', search);
        }
        return this._http.get<PageModel<TreatmentType>>(`${basePath}/doctor-preferences/treatment-types`, { params });
    }

    listByOfficeAndTreatmentType(officeId: string, treatmentTypeId: number) {
        const params = new HttpParams().set('officeId', officeId).set('treatmentTypeId', treatmentTypeId);
        return this._http.get<DoctorPreference[]>(`${basePath}/doctor-preferences`, { params });
    }

    saveByOffice(model: {
        officeId: string;
        treatmentTypeId: number;
        id?: string | null;
        designPreference?: string | null;
        translation?: string | null;
    }) {
        return this._http.post<{}>(`${basePath}/doctor-preferences`, model);
    }

    deleteByOffice(id: string, officeId: string, treatmentTypeId: number) {
        const params = new HttpParams()
            .set('officeId', officeId)
            .set('treatmentTypeId', treatmentTypeId);
        return this._http.delete(`${basePath}/doctor-preferences/${id}`, { params });
    }
}
